import { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';
import { Group } from '@mantine/core';

const QuestionTitle = styled.div`
	font-size: 17px;
	flex-grow: 1;
`;

const QuestionNumber = styled.div`
	width: 38px;
	height: 38px;
	background: ${(props) => props.theme.colors.slateBlue};
	font-weight: bold;
	color: white;
	border-radius: 38px;
	line-height: 38px;
	text-align: center;
	flex-shrink: 0;
`;

const QuestionContainer = styled.div`
	margin-bottom: 32px;
`;

const QuestionDescription = styled.div`
	margin-top: 8px;
	margin-bottom: 16px;
`;

export default function Question({
	title,
	number,
	description,
	children,
	rightSection,
}: PropsWithChildren<{
	title: string;
	description?: string | ReactNode;
	number: number;
	rightSection?: ReactNode;
}>) {
	return (
		<QuestionContainer>
			<Group>
				<QuestionNumber>{number}</QuestionNumber>
				<QuestionTitle>{title}</QuestionTitle>
				{rightSection}
			</Group>

			{description && (
				<QuestionDescription>
					<ParagraphSmall color="slateBlue">{description}</ParagraphSmall>
				</QuestionDescription>
			)}
			{children}
		</QuestionContainer>
	);
}
